import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import { FileUpload, Phone, SelectInput, TextArea, TextInput } from '../../components/FormComponents'
import PageTitle from '../../components/PageTitle'
import Table from '../../components/Table'
import FeatherIcon from 'feather-icons-react';
import Popup from '../../components/Popup';
import { VerticalForm } from '../../components'
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import 'yup-phone';

const API = process.env.REACT_APP_CLIENT_IP;

function UserSettings() {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [data, setData] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [inputData, setInputData] = useState({})
    const [validated, setValidated] = useState({ progress: false, login: false });
    const [notify, setNotify] = useState({ show: false, variant: '', message: '' })
    const [showPop, setShowPop] = useState({ show: false, dataId: '' })
    const [filesForUpload, setFilesForUpload] = useState({
        selectedFiles: undefined,previewImages: [],
        progressInfos: [],message: [],imageInfos: [],
      });

    const columns = [
        {
            Header: 'Photo',
            accessor: 'userPhoto',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                return <img src={`data:${original.imageType};base64, ${original.imageData}`} className="rounded-circle" alt="" height={'30'} />
            }
        },
        {
            Header: 'User Name',
            accessor: 'userName',
            sort: true,
        },
        {
            Header: 'Telephone',
            accessor: 'mobileTel',
            sort: false,
        },
        {
            Header: 'Email',
            accessor: 'email',
            sort: false,
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                //console.log(cell.cell.row.id)
                return <div style={{ display: 'flex', flexDirection: 'row', border: 'none', alignItems: 'center' }}>
                    <FeatherIcon onClick={() => {
                        setShow(true); setInputData(original);
                    }} style={{ cursor: 'pointer' }} className="icon-dual-info" icon="edit-2" />
                    <FeatherIcon onClick={() => {
                        setShowPop({ show: true }); setInputData(original)
                    }} style={{ marginLeft: '3px', cursor: 'pointer' }} className="icon-dual-danger" icon="trash-2" />
                </div>
            }
        }
    ];

    const sizePerPageList = [
        {
            text: '5',
            value: 5,
        },
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: 'All',
            value: data.length,
        },
    ];

    const schema = yup.object().shape({
        userName: yup.string().required(t('Please enter User Role Name')),
        email: yup.string().required('Please enter Email').email('Please enter valid Email'),
        mobileTel: yup.string().phone('UG').required('Please enter valid phone number'),
        password: yup.string().required(t('Please enter Password')),
        confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Passwords must match'),
    })

    const schemaResolver = yupResolver(schema);

    const handleChange = (event) => {
        const { name, value } = event.target
        setInputData({
            ...inputData, [name]: value
        })
        if (name === 'userName' && value !== ''||name==='mobileTel'&&value.length==10&& isNaN(value)=== false||name==='email'&& new RegExp(/\S+@\S+\.\S+/).test(value)
        ||name=== 'password'&&value.length>6|| name=== 'confirmPassword'&&inputData.password===value) {
            setValidated({ ...validated, [name]: false });
        } else { setValidated({ ...validated, [name]: true }); }
    }

    const selectFiles = (event) => {
        let images = [];
        for (let i = 0; i < event.target.files.length; i++) {
            images.push(URL.createObjectURL(event.target.files[i]))
        }
        setFilesForUpload({
            progressInfos: [],
            message: [],
            selectedFiles: event.target.files,
            previewImages: images,
        }); 
        handleChange(event);
    }

    const fetchRecords = async () => {
        let res = await fetch(`${API}/api/user/list`).then(response => response.json());
        if (res.success) {
            setData(res.data);
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            let isValid = schema.validateSync(inputData)
            if (isValid) {
                if (inputData.userAccountId === 0 || inputData.userAccountId === undefined) {
                    inputData.userAccountId = undefined;
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/user/create`, {
                            method: 'POST',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Saved Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" })
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/user/${inputData.userAccountId}`, {
                            method: 'PUT',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Updated Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" });
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        } catch (error) {
            error && setValidated({ userName: true, email: true, password: true,
                confirmPassword: true, mobileTel: true, userRoleName: true, isVerified: true
            });
        }
    };

    const onDelete = async (id) => {
        try {
            let res = await fetch(`${API}/api/user/${id}`, {
                method: 'DELETE'
            }).then(response => response.json());
            if (res.success) {
                fetchRecords();
                setInputData({});
                setShowPop({ show: false, dataId: '' })
                setNotify({
                    show: true,
                    message: "Deleted Successfully!",
                    variant: "success",
                });
                setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
            } else {
                setNotify({
                    show: true,
                    message: `${res.data.error.msg}`,
                    variant: "danger",
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {fetchRecords();}, []);
  return (
    <React.Fragment>
        <PageTitle
            breadCrumbItems={[
                { label: 'User Settings', path: '/settings/users' },
                { label: 'User List', path: '/settings/users', active: true },
            ]}
            title={'User List'}
        />
            <Popup show={showPop.show}
                handleClose={() => setShowPop({ show: false })}
                handleDelete={() => onDelete(inputData.userId)}
            />
            <Alert show={notify.show} variant={notify.variant} >{notify.message}</Alert>

            <Modal show={show} size='lg' centered>
                <Modal.Header onHide={handleClose} closeButton>
                    <p className="text-muted fs-14">
                        Fill in the required details
                    </p>
                </Modal.Header>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>

                                <VerticalForm resolver={schemaResolver} onSubmit={handleSubmit}>
                                    <Row>
                                        <Col lg={12}>
                                            <TextInput
                                                textTitle={'User Name'}
                                                textName='userName'
                                                value={inputData.userName}
                                                required={!inputData.userName&&validated.userName}
                                                onChange={handleChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <Phone
                                                phoneTitle={'Phone Number'}
                                                phoneName='mobileTel'
                                                onChange={handleChange}
                                                required={validated.mobileTel}
                                                value={inputData.mobileTel}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                    <Col lg={12}>
                                        <TextInput
                                            textTitle={'User Email'}
                                            textName='email'
                                            value={inputData.email}
                                            required={validated.email}
                                            onChange={handleChange}
                                        />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <TextInput
                                                textTitle={'Password'}
                                                textName='password'
                                                onChange={handleChange}
                                                value={inputData.password}
                                                required= {validated.password}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <TextInput
                                                textTitle={'Confirm Password'}
                                                textName='confirmPassword'
                                                onChange={handleChange}
                                                value={inputData.confirmPassword}
                                                required= {validated.confirmPassword}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={12}>
                                            <FileUpload
                                            fileName= 'imageData'
                                            fileTitle= 'User Image'
                                            onChange={selectFiles}
                                            />
                                            {filesForUpload.previewImages && (
                                                <div>
                                                    {filesForUpload.previewImages.map((img, i) => {
                                                        return <img height="100" width='50%' src={img} alt={"image-" + i} key={i} />;
                                                    })} 
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Button style={{ float: 'right' }} variant="primary" type="submit" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </VerticalForm>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col xs={8}>
                                    <h4 className="header-title">users</h4>
                                    <p className="text-muted fs-14 mb-4">List of users</p>
                                </Col>
                                <Col xs={4}>
                                    <Button style={{ float: 'right' }} variant="success"
                                        type="submit" className="btn-sm" onClick={handleShow}>
                                        Add New
                                        <i className='bi-plus-lg' style={{ marginLeft: '5px', fontSize: '' }}></i>
                                    </Button>
                                </Col>
                            </Row>

                            <Table
                                columns={columns}
                                data={data}
                                pageSize={5}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSearchable={true}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
    </React.Fragment>
  )
}

export default UserSettings